class UniversalHeader extends HTMLElement {
    constructor() {
        super();
        let universalHeaderDebounce = debounce(() => this.universalHeaderResize.bind(this), 500)
        this.querySelectorAll('.universal-header-btn').forEach((button) => button.addEventListener('click', this.universalButtonClick.bind(this)));
        window.addEventListener("resize", () => universalHeaderDebounce());
        this.universalDropdown = this.querySelector('.universal-header-container');
        this.universalDropdownButton = this.querySelector('.universal-header-btn');
    }

    universalButtonClick(event){
        event.preventDefault();
        this.universalDropdown.classList.toggle('open');
        this.universalDropdownButton.classList.toggle('open');
    }

    universalHeaderResize() {
        const universalHeaderRemove = this.universalDropdown;
        const universalHeaderBlockRemove = document.querySelectorAll('.universal-block');
        if (window.innerWidth > 768) {
            universalHeaderRemove.classList.remove('open');
            this.universalDropdownButton.classList.remove('open');
            universalHeaderBlockRemove.forEach((element) => {
                element.classList.remove('fade-in', 'fade-in-up', 'fade-in-down');
            });
        }
    }

}

customElements.define('universal-header', UniversalHeader);

/*** Universal Header Modal ***/
const universalHeaderBodyLock = document.querySelector('body');
const universalHeaderModalButton = document.querySelector('.universal-header-modal__button');
const universalheaderModalContent = document.querySelector('.universal-header-modal');
const universalHeaderOverlay = document.querySelector('.universal-header-overlay');
universalHeaderModalButton.addEventListener("click", function() {
    this.classList.toggle('open');
    universalheaderModalContent.classList.toggle('open');
    universalHeaderOverlay.classList.toggle('active');
    universalHeaderBodyLock.classList.toggle('overflow-hidden');
});
universalHeaderOverlay.addEventListener("click", function() {
    this.classList.remove('active');
    universalHeaderModalButton.classList.remove('open');
    universalheaderModalContent.classList.remove('open');
    universalHeaderBodyLock.classList.remove('overflow-hidden');
});

/*** Universal Header Tabs ***/
const universalHeaderTabButton = document.querySelectorAll('.parent-link-tab');
const universalHeaderTabContent = document.querySelectorAll('.universal-tab-container');
universalHeaderTabButton.forEach(button => {
    button.addEventListener('click', () => {
        // Deactivate all tabs and content
        universalHeaderTabButton.forEach(btn => btn.classList.remove('active'));
        universalHeaderTabContent.forEach(content => content.classList.remove('active'));
        // Activate the clicked tab and corresponding content
        button.classList.add('active');
        const tabId = button.dataset.tab;
        document.getElementById(tabId).classList.add('active');
    });
});

/*** Universal Header Dropdown ***/
const universalHeaderMobileMenu = document.querySelector('.universal-header-mobile-navigation-menu');
const universalHeaderListItems = universalHeaderMobileMenu.querySelectorAll('li');
universalHeaderListItems.forEach(item => {
    item.addEventListener('click', (event) => {
        item.classList.toggle('active');
        const nestedUl = item.querySelector('ul');
        if (nestedUl) {
            nestedUl.classList.toggle('open');
        }
        event.stopPropagation();
    });
});